import { useMutation, useQueryClient } from "@tanstack/react-query";

import { applySegmentChanges } from "services";

import { APPLY_FEATBIT_SEGMENT_CHANGES, GET_FEATBIT_SEGMENT_ENTRIES } from "consts";

export const useApplySegmentChanges = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [APPLY_FEATBIT_SEGMENT_CHANGES],
    mutationFn: applySegmentChanges,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [GET_FEATBIT_SEGMENT_ENTRIES] }),
  });
};
